import { CreateOrderDialogMode } from "../createOrderTypes"
import { InitialEventState } from "../components/resource/ResourceBookingDraftContext"
import { OrderContextState } from "../mainForm/helpers"
import { UserDetailsProps } from "../orderOnBehalf/OrderOnBehalfFlow"

export const defaultOrderContextState: OrderContextState = {
    mode: CreateOrderDialogMode.CREATE,
    orderId: undefined,
}

export const defaultUserDetailsState: UserDetailsProps = {
    companyId: undefined,
    companyGroupId: undefined,
    selectedUserId: undefined,
    selectedUserName: undefined,
}

export const defaultInitialEventState: InitialEventState = {
    event: null,
    initValues: null,
    isUpdated: false,
}
